module.exports = __webpack_public_path__ + "static/img/CZ.ede29f92.png";